module.exports = __webpack_public_path__ + "img/bookmark-dash.740c20a2.svg";